import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { type IoniconIconName } from "@/schemas/icons";

type InterestAttributesProps = {
  icon: IoniconIconName;
  title: string;
  items: AttributeValue[];
};

function Card({ iconLabel, label }: AttributeValue): React.JSX.Element {
  return (
    <View style={styles.card}>
      <Text style={styles.emoticon}>{iconLabel}</Text>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
}

function MultiSelectionAttributes({
  icon,
  title,
  items,
}: InterestAttributesProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Ionicons name={icon} size={25} color="#01579b" />
        <Text style={styles.sectionTitle}>{title}</Text>
      </View>
      <View style={styles.infoGrid}>
        {items.map((lang, index) => (
          <Card key={index} {...lang} />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  titleContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: 5,
  },
  infoGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  card: {
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: 20,
    elevation: 2,
    flexDirection: "row",
    marginBottom: 2,
    marginRight: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    shadowColor: "#000",
    shadowOffset: { height: 1, width: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 1,
  },
  emoticon: {
    marginRight: 8,
  },
  label: {},
});

export default MultiSelectionAttributes;
